import {Box, Button, Card, CircularProgress, Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';

import {MainFooter, MainHeader, StyledGrid} from 'presentation/components';
import {HomeEnum, ProfileEnum} from 'presentation/constants';
import {useAccountInformation, useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';

import {useDataSharingFeatures} from './hooks/useDataSharingFeatures';
import {FeatureItem} from '../../components';

const {featuresTitle, featuresEnabledTitle, back} =
	translations['pt-br'].privateFlow.profile.dataSharing;

export function DataSharingFeatures() {
	const navigate = useNavigate();
	const {isLaptop} = useMediaQueries();
	const {canChangeAccess} = useAccountInformation();
	const {isShareAccessEnabled, isFeaturesApiEnabled, isFetchingFeatures, features, layout} =
		useDataSharingFeatures();

	const handleBack = () => {
		navigate(ProfileEnum.DATA_SHARING);
	};

	const renderFeaturesInColumns = () => (
		<StyledGrid.Root gap={1}>
			{features.map(feature => (
				<StyledGrid.Item key={feature.key} xs={12} sm={6}>
					<FeatureItem feature={feature} iconSize={layout.iconSize} />
				</StyledGrid.Item>
			))}
		</StyledGrid.Root>
	);

	const renderFeaturesInList = () =>
		features.map(feature => (
			<FeatureItem key={feature.key} feature={feature} iconSize={layout.iconSize} />
		));

	const renderFeatures = () => {
		if (isFetchingFeatures) {
			return (
				<Stack alignItems="center" py={2}>
					<CircularProgress size={24} />
				</Stack>
			);
		}

		return isFeaturesApiEnabled ? renderFeaturesInColumns() : renderFeaturesInList();
	};

	if (!isShareAccessEnabled || !canChangeAccess) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return (
		<Fragment>
			<MainHeader
				title={featuresTitle}
				handleBack={handleBack}
				handleClose={handleBack}
				variant="subRoute"
			/>

			<Stack padding={isLaptop ? 2 : 4} flex={1}>
				<StyledGrid.Root>
					<StyledGrid.Item xs={12} md={layout.contentColumns} lg={layout.contentColumns}>
						<Stack gap={3}>
							<Card elevation={0} sx={{p: 2, borderRadius: 1}}>
								<Stack gap={1.5}>
									<Typography
										variant="body2"
										color="text.secondary"
										fontWeight={600}>
										{featuresEnabledTitle}
									</Typography>
									{renderFeatures()}
								</Stack>
							</Card>

							<Stack alignItems="flex-end">
								<Button variant="contained" size="large" onClick={handleBack}>
									{back}
								</Button>
							</Stack>
						</Stack>
					</StyledGrid.Item>
				</StyledGrid.Root>
			</Stack>

			<Box mt="auto">
				<MainFooter />
			</Box>
		</Fragment>
	);
}
